/** @format */
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import NativeSelect from '@mui/material/NativeSelect';
import FormControl from '@mui/material/FormControl';
import {
  getPairingModelAvailableModelsStart,
  setSelectedPairingModel,
  getSelectedPairingModelDataStart,
  clearSelectedPairingModelData,
} from '../../redux/pairing-model/pairing-model.actions';

import {
  selectPairingModelAvailableModels,
  selectPairingModelSelectedModel,
  selectPairingModelSelectedModelDetails,
} from '../../redux/pairing-model/pairing-model.selectors';
import * as d3 from 'd3';
import * as d3Sankey from 'd3-sankey';

import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useWindowDimensions from '../../utils/useWindowDimensions.hook';
import _ from 'lodash';

let dimensions = {
  width: 1600,
  height: 880,
  contextHeight: 240,
  focusHeight: 640,
  margin: {
    top: 20,
    right: 200,
    bottom: 20,
    left: 20,
  },
};

// function dragmove(d) {
//     d3.select(this)
//       .attr("transform",
//             "translate("
//                + d.x + ","
//                + (d.y = Math.max(
//                   0, Math.min(height - d.dy, d3.event.y))
//                  ) + ")");
//     sankey.relayout();
//     link.attr("d", sankey.link() );
//   }

const SankeyChartComponent = () => {
  const svgRef = useRef();
  let windowDimensions = useWindowDimensions();
  const dispatch = useDispatch();
  const availableModels = useSelector(selectPairingModelAvailableModels);
  const selectedModel = useSelector(selectPairingModelSelectedModel);
  const selectedModelDetails = useSelector(
    selectPairingModelSelectedModelDetails
  );

  const [numStations, setNumStations] = useState(0);
  const [numNodes, setNumNodes] = useState(0);
  const [stateNodes, setStateNodes] = useState([]);
  const [stateLinks, setStateLinks] = useState([]);
  const [linkColor, setLinkColor] = useState('source-target');
  const [alignment, setAlignment] = useState('center');
  const alignmentOptions = {
    center: d3Sankey.sankeyCenter,
    justify: d3Sankey.sankeyJustify,
    left: d3Sankey.sankeyLeft,
    right: d3Sankey.sankeyRight,
  };
  const linkColorOptions = ['source-target', 'source', 'target'];

  const calculateDepth = (pairing, flight) => {
    let depth = 0;
    for (let duty of pairing.duties) {
      let found = false;
      for (let f of duty.flights) {
        depth++;
        if (f.idx === flight.idx) {
          found = true;
          break;
        }
      }
      if (found) {
        break;
      }
    }
    return depth;
  };

  useEffect(() => {
    if (stateNodes.length > 0 && stateLinks.length > 0) {
      let svg = d3.select(svgRef.current);

      svg.selectAll('*').remove();
      d3.dragEnable(window);
      let width = windowDimensions.width * 0.9;
      let height = windowDimensions.height * 0.9;

      let sankey = d3Sankey
        .sankey()
        .nodeId((d) => d.id)
        .nodeAlign(alignmentOptions[alignment])
        .nodeWidth(15)
        .nodePadding(10)
        .extent([
          [dimensions.margin.left, dimensions.margin.top],
          [width - dimensions.margin.right, height - dimensions.margin.bottom],
        ]);

      let { nodes, links } = sankey({
        nodes: stateNodes.map((d) => {
          return { ...d, nodeClicked: false };
        }),
        links: stateLinks.map((d) => {
          return { ...d };
        }),
      });
      //   console.log(nodes, links);
      let color = d3.scaleOrdinal(d3.schemeCategory10);

      let rects = svg
        .append('g')
        .attr('stroke', '#000')
        .selectAll('rect')
        .data(nodes)
        .join('rect')
        .classed('node', true)
        .attr('id', (d) => `rect-${d.id}`)
        .attr('x', (d) => d.x0)
        .attr('y', (d) => d.y0)
        .attr('height', (d) => d.y1 - d.y0)
        .attr('width', (d) => d.x1 - d.x0)
        .attr('fill', (d) => color(d.group));
      // .datum({ nodeClicked: false });

      // .call(
      //   d3
      //     .drag()
      //     .subject((d) => d)
      //     .on('drag', function (event, d) {
      //       //   console.log(event, d);
      //       let currRect = d3.select(this).attr('y', (d.y0 = event.y));
      //       sankey.update({ nodes: nodes, links: links });
      //       //   console.log(currRect.data());
      //       svg
      //         .selectAll('.link')
      //         .filter((d) => {
      //           // console.log(d);
      //           return (
      //             d.source.id === currRect.data()[0].id ||
      //             d.target.id === currRect.data()[0].id
      //           );
      //         })
      //         .attr('d', d3Sankey.sankeyLinkHorizontal());
      //       //   svg
      //       //     .selectAll('rect')
      //       //     .attr('y', (d) => d.y0)
      //       //     .attr('x', (d) => d.x0);
      //       svg
      //         .selectAll('text')
      //         .attr('x', (d) => (d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6))
      //         .attr('y', (d) => (d.y1 + d.y0) / 2);
      //     })
      // );

      rects
        .append('title')
        // .attr('id', (d) => `text-${d.id}`)
        .text((d) => `${d.label}`);

      rects
        .on('click', (event, d) => {
          highlight_node_links(event, d);
        })
        .on('mouseover', function (event, d) {
          d3.select(this).style('cursor', 'pointer');
        });

      let connections = svg
        .append('g')
        .attr('fill', 'none')
        .attr('stroke-opacity', 0.5)
        .selectAll('g')
        .data(links)
        .join('g')
        .style('mix-blend-mode', 'multiply');

      let gradient = connections
        .append('linearGradient')
        .attr('id', (d) => {
          d.uid = _.uniqueId(d.source.id + d.target.id + '_');
          return d.uid;
        })
        .attr('gradientUnits', 'userSpaceOnUse')
        .attr('x1', (d) => d.source.x1)
        .attr('x2', (d) => d.target.x0);

      gradient
        .append('stop')
        .attr('offset', '0%')
        .attr('stop-color', (d) => color(d.source.group));

      gradient
        .append('stop')
        .attr('offset', '100%')
        .attr('stop-color', (d) => color(d.target.group));

      connections
        .append('path')
        .attr('class', (d) => `link link-${d.source.id}-${d.target.id}`)
        .attr('id', (d) => `link-${d.uid}`)
        .attr('d', d3Sankey.sankeyLinkHorizontal())
        .attr('stroke', (d) => {
          if (linkColor === 'source-target') {
            return `url(#${d.uid})`;
          } else if (linkColor === 'source') {
            return color(d.source.group);
          } else if (linkColor === 'target') {
            return color(d.target.group);
          }
        })
        .attr('stroke-width', (d) => d.width)
        .style('mix-blend-mode', 'multiply')
        .append('title')
        .text((d) => ``);

      svg
        .append('g')
        .style('font', '10px sans-serif')
        .selectAll('text')
        .data(nodes)
        .join('text')
        .attr('id', (d) => `text-${d.id}`)
        .classed('node-label', true)
        .style('opacity', 1)
        .style('font-size', 12)
        .style('font-weight', 'normal')
        .attr('x', (d) => (d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6))
        .attr('y', (d) => (d.y1 + d.y0) / 2)
        .attr('dy', '0.35em')
        .attr('text-anchor', (d) => (d.x0 < width / 2 ? 'start' : 'end'))

        .text((d) => d.label);
      // .append('tspan')
      // .attr('fill-opacity', 0.7)
      // .text((d) => ` ${d.label.split(' ')[0]}`);
    }

    return () => {
      d3.select(svgRef.current).selectAll('*').remove();
      // dispatch(clearSelectedPairingModelData());
    };
  }, [stateNodes, stateLinks, linkColor, alignment, windowDimensions]);

  useEffect(() => {
    if (numNodes > 0 && numStations > 0) {
      let nodes = [];
      let links = [];
      selectedModelDetails?.forEach((pairing) => {
        pairing.duties.forEach((duty) => {
          duty.flights.forEach((flight) => {
            let depth = calculateDepth(pairing, flight);
            let originIndex = nodes.findIndex(
              (node) => node.id === flight.departure_station + depth
            );
            let destinationIndex = nodes.findIndex(
              (node) => node.id === flight.arrival_station + (depth + 1)
            );
            if (originIndex === -1) {
              nodes.push({
                id: flight.departure_station + depth,
                label: flight.departure_station,
                group: depth,
              });
            }
            if (destinationIndex === -1) {
              nodes.push({
                id: flight.arrival_station + (depth + 1),
                label: flight.arrival_station,
                group: depth + 1,
              });
            }
            links.push({
              source: flight.departure_station + depth,
              target: flight.arrival_station + (depth + 1),
              value: 1,
            });
          });
        });
      });
      nodes = _.uniqBy(nodes, 'id');

      links = links.reduce((acc, curr) => {
        let found = acc.find(
          (link) => link.source === curr.source && link.target === curr.target
        );
        if (found) {
          found.value++;
        } else {
          acc.push(curr);
        }
        return acc;
      }, []);
      //   console.log(links);
      //   console.log(reduced_links);

      setStateNodes(nodes);
      setStateLinks(links);
    }
  }, [numNodes, numStations]);

  useEffect(() => {
    if (selectedModel) {
      dispatch(getSelectedPairingModelDataStart(selectedModel.name));
    }
  }, [dispatch, selectedModel]);

  useEffect(() => {
    if (selectedModelDetails) {
      let maxFlights = selectedModelDetails.reduce((max, pairing) => {
        return Math.max(max, pairing.total_num_flights);
      }, 0);

      let stations = new Set();
      selectedModelDetails.forEach((pairing) => {
        pairing.duties.forEach((duty) => {
          duty.flights.forEach((flight) => {
            stations.add(flight.departure_station);
            stations.add(flight.arrival_station);
          });
        });
      });
      setNumStations(stations.size);
      setNumNodes(stations.size * maxFlights + stations.size);
    }
  }, [selectedModelDetails]);

  useEffect(() => {
    dispatch(getPairingModelAvailableModelsStart());
  }, [dispatch]);

  return (
    <Box>
      <FormControl
        required
        fullWidth
        sx={{
          p: '2%',
        }}
      >
        <InputLabel
          variant="standard"
          htmlFor="select-available-paring-models-controlled-native"
          size="large"
        >
          Select a model
        </InputLabel>
        <NativeSelect
          defaultValue={selectedModel ? selectedModel.name : ''}
          onChange={(event) => {
            // setSelectedModel(event.target.value);
            let model = availableModels.find(
              (m) => m.name === event.target.value
            );
            dispatch(setSelectedPairingModel(model));
          }}
          inputProps={{
            name: 'Select a model',
            id: 'select-available-paring-models-controlled-native',
          }}
        >
          <option aria-label="None" value="" />
          {availableModels.map((model) => {
            return (
              <option key={model.name + model.expiry} value={model.name}>
                {model.name}
              </option>
            );
          })}
        </NativeSelect>
      </FormControl>
      <Box
        sx={{
          p: '2%',
        }}
      >
        <FormControl
          required
          sx={{
            width: '50%',
            p: '2%',
          }}
        >
          <InputLabel
            variant="standard"
            htmlFor="select-link-color-controlled-native"
            size="large"
          >
            Select a link color
          </InputLabel>
          <NativeSelect
            defaultValue={linkColor}
            onChange={(event) => {
              // setSelectedModel(event.target.value);
              setLinkColor(event.target.value);
            }}
            inputProps={{
              name: 'Select a link color',
              id: 'select-link-color-controlled-native',
            }}
          >
            <option aria-label="None" value="" />
            {linkColorOptions.map((option) => {
              return (
                <option key={option} value={option}>
                  {option}
                </option>
              );
            })}
          </NativeSelect>
        </FormControl>

        <FormControl
          required
          sx={{
            p: '2%',
            width: '50%',
          }}
        >
          <InputLabel
            variant="standard"
            htmlFor="select-alignment-controlled-native"
            size="large"
          >
            Select an alignment
          </InputLabel>
          <NativeSelect
            defaultValue={alignment}
            onChange={(event) => {
              // setSelectedModel(event.target.value);
              setAlignment(event.target.value);
            }}
            inputProps={{
              name: 'Select an alignment',
              id: 'select-alignment-controlled-native',
            }}
          >
            <option aria-label="None" value="" />
            {Object.keys(alignmentOptions).map((option) => {
              return (
                <option key={option} value={option}>
                  {option}
                </option>
              );
            })}
          </NativeSelect>
        </FormControl>
      </Box>

      <svg
        ref={svgRef}
        width={dimensions.width}
        height={dimensions.height}
      ></svg>
    </Box>
  );
};

export default SankeyChartComponent;

function highlight_node_links(event, node) {
  // console.log(event);
  console.log(node.id, ': ', node.nodeClicked, 'Clicked');
  let remainingNodes = [],
    nextNodes = [];
  let currNode = d3.select(this);

  if (node.nodeClicked === true) {
    let nodeUpdate = d3
      .selectAll('.node')
      .data([{ ...node, nodeClicked: false }]);

    // d3.selectAll('.link').style('opacity', 1); // back to default
    // d3.selectAll('.node').style('opacity', 1);

    // d3.selectAll('.node-label')
    //   .style('opacity', 1)
    //   .style('font-size', 12)
    //   .style('font-weight', 'normal');
    // return;
  } else {
    let nodeUpdate = d3
      .selectAll('.node')
      .data([{ ...node, nodeClicked: true }]);
    // currNode.data({ ...node, nodeClicked: true });
    // Update the nodes…
  }

  let selectedNodes = d3.selectAll('.node').filter((d) => d.nodeClicked);
  let unselectedNodes = d3.selectAll('.node').filter((d) => !d.nodeClicked);

  console.log('selected nodes', selectedNodes.data().length);
  console.log('unselected nodes', unselectedNodes.data().length);

  unselectedNodes.each(function (d, i) {
    traverseAllConnections(d, [], [], 0.1);
  });
  selectedNodes.each(function (d, i) {
    traverseAllConnections(d, [], [], 1);
  });

  d3.select('#rect-' + node.id).style('opacity', 1);
  d3.select('#text-' + node.id)
    .style('opacity', 1)
    .style('font-size', 16)
    .style('font-weight', 'bold');
  // }

  ({ remainingNodes, nextNodes } = traverseAllConnections(
    node,
    remainingNodes,
    nextNodes,
    1
  ));
}
function traverseAllConnections(node, remainingNodes, nextNodes, opacity) {
  let traverse = [
    {
      linkType: 'sourceLinks',
      nodeType: 'target',
    },
    {
      linkType: 'targetLinks',
      nodeType: 'source',
    },
  ];

  //   console.log('starting traversal');
  const start = performance.now();

  traverse?.forEach(function (step) {
    node[step.linkType].forEach(function (link) {
      remainingNodes.push(link[step.nodeType]);
      d3.select('#link-' + link.uid).style('opacity', opacity);
    });

    while (remainingNodes.length) {
      nextNodes = [];
      remainingNodes?.forEach(function (n) {
        n[step.linkType].forEach(function (link) {
          nextNodes.push(link[step.nodeType]);

          d3.select('#link-' + link.uid).style('opacity', opacity);
        });

        d3.select('#rect-' + n.id).style('opacity', opacity);
        d3.select('#text-' + n.id).style('opacity', opacity);
      });
      remainingNodes = nextNodes;
    }
  });
  const end = performance.now();
  //   console.log('Traversal time: ', end - start);
  return { remainingNodes, nextNodes };
}
